import { IMyWindow } from '@aca-new/app/shared/interfaces/my-window.interface';
import { QimaOptionalType } from '@qima/ngx-qima';

/**
 * @description
 * Resolves the AppCues account id from `environment-params.js` (`var appcuesAccountId` on window).
 * @param {IMyWindow} window - Browser window.
 * @returns {string | null} AppCues account id string, or null when disabled or missing.
 */
export function appcuesAccountIdFactory(window: IMyWindow): QimaOptionalType<string> {
  const accountId = window.appcuesAccountId;

  if (accountId == null || accountId === 0) {
    return null;
  }

  return accountId.toString();
}
